import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class SkillService {
    constructor(http) {
        this.http = http;
        this.baseUrl = environment.apiurl + 'api/v1/';
    }
    getSkills(id, skip, limit) {
        let url = this.baseUrl + 'skills';
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                topicId: id.toString(),
                skip: skip.toString(),
                limit: limit.toString()
            })
        };
        console.log("headers>>", httpOptions.headers);
        return this.http.get(url, httpOptions).pipe(map((res) => {
            let result = [];
            result.push(res);
            console.log("skill service res>>", result);
            return result;
        }));
    }
}
SkillService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SkillService_Factory() { return new SkillService(i0.ɵɵinject(i1.HttpClient)); }, token: SkillService, providedIn: "root" });
